import React, { useContext } from 'react';

const ModalDialogSwipeContext = React.createContext<undefined | boolean>(undefined);

export const useModalDialogSwipeContext = () => useContext(ModalDialogSwipeContext);

export default ModalDialogSwipeContext;
